import { Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { ComunicacionapiService } from './comunicacionapi.service';
import { Constantes } from '../models/modules/Constantes';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class ProspectosCargaService {
  
  constructor(private configInicial: ConfiguracionInicialService,
    private comunicacionapiService: ComunicacionapiService) {
      
  }

  ConsultarAliados(): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PROSPECTOSCARGA_CONSULTARALIADOS()}`;
    return this.comunicacionapiService.Get(urlServicio);
  }
  ConsultarPendientes(): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PROSPECTOSCARGA_CONSULTAR()}`;
    return this.comunicacionapiService.Get(urlServicio);
  }
  Consultar(idAplicacion: number): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PROSPECTOSCARGA_CONSULTAR()}/${idAplicacion}`;
    return this.comunicacionapiService.Get(urlServicio);
  }
  Anular(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PROSPECTOSCARGA_ANULAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  Procesar(archivo: any, idAplicacion: number, idAliado: number): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PROSPECTOSCARGA_PROCESAR()}/${idAplicacion}/${idAliado}`;
    return this.comunicacionapiService.Post(urlServicio, archivo);
  }
  DescargarArchivo(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PROSPECTOSCARGA_DESCARGARARCHIVO()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
}
